import { render, staticRenderFns } from "./ContactInfoBox.vue?vue&type=template&id=414ff5d9&"
import script from "./ContactInfoBox.vue?vue&type=script&lang=js&"
export * from "./ContactInfoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports